import request from '@/util/request'


export const trainTongji = (data) => request.post('/api/trainTongji', data);  //管理培训统计